import { Injectable } from '@angular/core'

import { Observable, Subject } from 'rxjs'
import { MenuItem } from '../../base/models/menu-items';
import { select, Store } from '@ngrx/store';
import * as fromMenus from '../../base/reducers'

@Injectable()
export class MenuControlService {
  private triggerSubject = new Subject<string>()
  public activeAccordionId = new Subject<string>()
  public activeAccordionChain = new Subject<string[]>()
  sideMenuItems$: Observable<MenuItem[]>

  constructor(private store: Store<any>) {
    this.sideMenuItems$ = this.store.pipe(select(fromMenus.getSideMenuList))
  }

  get trigger$() : Observable<string> {
    return this.triggerSubject.asObservable()
  }

  trigger(id: string) {
    this.triggerSubject.next(id)
  }

  setActiveAccordion(id: string) {
    this.activeAccordionId.next(id)
  }
}
